exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table td,.table th{padding-left:5px!important;padding-top:2px;padding-bottom:2px}", ""]);

// exports
